import { Component, OnInit, ViewChild, Input, EventEmitter, Output, ContentChild, OnDestroy } from '@angular/core';
import { MatTab } from '@angular/material/tabs';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';
import { CSTCustomPage } from '../models/cst-custom-page.model';
import { CustomPageViewerComponent } from '../custom-page-viewer/custom-page-viewer.component';
import { DesignPageViewerComponent } from '../design-page-viewer/design-page-viewer.component';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { CustomFieldDataObject } from '../models/custom-data-field.model';

@AutoUnsubscribe({ includeArrays: true })
@Component({
  selector: 'custom-page-tab',
  templateUrl: './custom-page-tab.component.html',
  styleUrls: ['./custom-page-tab.component.css']
})
export class CustomPageTabComponent implements OnInit, OnDestroy {

  subscriptions: Subscription[] = [];
  @ViewChild(MatTab, { static: true })
  public matTab: MatTab;

  private _pageComponent: CustomPageViewerComponent;
  @ViewChild(CustomPageViewerComponent, { static: false})
  public set pageComponent(page: CustomPageViewerComponent) {
    this._pageComponent = page;
    if (page) {
      page.dataStore = this.dataStore;
      page.isDirtyChange.subscribe(isDirty => {
        this.isDirty = isDirty;
      });
    }
  }
  public get pageComponent(): CustomPageViewerComponent {
    return this._pageComponent;
  }

  _designPageComponent: DesignPageViewerComponent;
  @ContentChild(DesignPageViewerComponent)
  public set designPageComponent(page: DesignPageViewerComponent) {
    this._designPageComponent = page;
    if (page) {
      page.dataStore = this.dataStore;
      if (this.tabGroupIsGettingMetadata) {
        page.tabGroupIsGettingMetadata = this.tabGroupIsGettingMetadata;
      }
      page.isDirtyChange.subscribe(val => {
        this._isDirty = val;
        if (val == true) {
          this.isDirtyChange.emit(true);
        }
      });
    }
  }
  public get designPageComponent(): DesignPageViewerComponent {
    return this._designPageComponent;
  }

  private _label: string;
  @Input() set label(value: string) {
    if (value) {
      this._label = value;
    }
    else {
      this._label = '';
    }
  }
  get label(): string {
    return this._label;
  }
  @Input() disabled: boolean;
  @Input() customPage: CSTCustomPage;
  private _masterId: number;
  get masterId(): number {
    return this._masterId;
  }
  @Input() set masterId(value: number) {
    this._masterId = value;
  }
  @Input() hideTitle = false;
  @Input() readOnly: boolean;
  @Input() validateFunction: () => ErrorList[];

  private _tabGroupIsGettingMetadata: boolean;
  public get tabGroupIsGettingMetadata(): boolean {
    return this._tabGroupIsGettingMetadata;
  }
  public set tabGroupIsGettingMetadata(value: boolean) {
    this._tabGroupIsGettingMetadata = value;
    if (this.designPageComponent) {
      this.designPageComponent.tabGroupIsGettingMetadata = value;
    }
  }

  private _isDirty: boolean;
  public get isDirty(): boolean {
    return this._isDirty;
  }
  public set isDirty(value: boolean) {
    this._isDirty = value;
    if (this.designPageComponent) {
      this.designPageComponent.isDirty = value;
    }
    if (value == true) {
      this.isDirtyChange.emit(value);
    }
  }

  private _dataStore: CustomFieldDataObject[] = [];
  public get dataStore(): CustomFieldDataObject[] {
    return this._dataStore;
  }
  public set dataStore(value: CustomFieldDataObject[]) {
    this._dataStore = value;
    if (this.pageComponent) {
      this.pageComponent.dataStore = value;
    }
    else if (this.designPageComponent) {
      this.designPageComponent.dataStore = value;
    }
  }

  @Output() isDirtyChange: EventEmitter<boolean> = new EventEmitter<boolean>();


  constructor() {

  }

  ngOnInit() {

  }

  ngOnDestroy() { }

}
